module.exports = __webpack_public_path__ + "img/train-8.739072b9.jpg";